import { render, staticRenderFns } from "./jinkou.vue?vue&type=template&id=7b73e414&scoped=true&"
import script from "./jinkou.vue?vue&type=script&lang=js&"
export * from "./jinkou.vue?vue&type=script&lang=js&"
import style0 from "./jinkou.vue?vue&type=style&index=0&id=7b73e414&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b73e414",
  null
  
)

export default component.exports